import React, { FC } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import PDFReports from 'pages/Main/Reporting/PDFReports';

import { Container } from './styles';

const Insights: FC = () => {
  return (
    <Container>
      <Switch>
        <Route exact path="/reporting/pdf-reports">
          <PDFReports />
        </Route>
        {/* <Route exact path="/insights/promos">
          <Promos brandId={selectedBrandId} />
        </Route> */}

        <Redirect to="/reporting/pdf-reports" />
      </Switch>
    </Container>
  );
};

export default Insights;
